import React from "react";
import { useParams } from "react-router-dom";
import AppShell from "./AppShell";
import InfoCard from "./InfoCard";
import { getApp } from "../../../Constants/Apps";
import { useDocumentTitle } from "../../../Hooks/useDocumentTitle";
import { useTranslation } from "../../../Hooks/useTranslation";

const AppPrivacy = () => {
  const { appId } = useParams();
  const { t } = useTranslation();
  const app = getApp(appId);
  useDocumentTitle(app ? `${t.apps.privacyTitle} · ${app.name}` : undefined);

  return (
    <AppShell>
      {({ content, t }) => (
        <section className="section app-section">
          <div className="container">
            <div data-reveal>
              <span className="eyebrow">{t.apps.privacyTitle}</span>
              <h2>{content.privacy.intro}</h2>
              <p className="app-updated">{content.privacy.date}</p>
            </div>
            <div className="row app-cards">
              {content.privacy.sections.map((item, index) => (
                <InfoCard key={item.title} item={item} writeUs={t.apps.writeUs} style={{ "--d": index % 3 }} />
              ))}
            </div>
          </div>
        </section>
      )}
    </AppShell>
  );
};

export default AppPrivacy;
